<form [formGroup]="form" [id]="fieldName">
  <div class="form-group field">
    @if (label) {
      <label for="{{ fieldName.toString() + '-number' }}" class="block"
        >{{ label }}
        @if (attribute?.displayNameSuffixIcon) {
          <i inline style="font-size: small">{{ attribute?.displayNameSuffixIcon }}</i>
        }
        @if (isRequired()) {
          <span style="color: red">*</span>
        }
      </label>
    }
    <p-editor #editor [formControlName]="fieldName" [style]="{ height: '320px' }" [readonly]="readonly">
      @switch (toolbar) {
        @case ('text') {
          <ng-template #header>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
              <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
            </span>
          </ng-template>
        }
        @case ('simple') {
          <ng-template #header>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold" type="button"></button>
              <button class="ql-italic" aria-label="Italic" type="button"></button>
              <button class="ql-underline" aria-label="Underline" type="button"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-align" [title]="'Alignment'">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
              <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
              <select class="ql-align">
                <option selected></option>
                <option value="center">center</option>
                <option value="right">right</option>
                <option value="justify">justify</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
            </span>
          </ng-template>
        }
        @case ('normal') {
          <ng-template #header>
            <span class="ql-formats">
              <select class="ql-header">
                <option value="1">Heading</option>
                <option value="2">Subheading</option>
                <option selected>Normal</option>
              </select>
              <select class="ql-font">
                <option selected>Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold" type="button"></button>
              <button class="ql-italic" aria-label="Italic" type="button"></button>
              <button class="ql-underline" aria-label="Underline" type="button"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
              <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
              <select class="ql-align">
                <option selected></option>
                <option value="center">center</option>
                <option value="right">right</option>
                <option value="justify">justify</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-link" aria-label="Insert Link" type="button"></button>
              <button class="ql-image" aria-label="Insert Image" type="button"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
            </span>
          </ng-template>
        }
      }
      <ng-content></ng-content>
    </p-editor>
    @if (displayHint || attribute?.displayHint) {
      <small class="block">
        {{ displayHint ? displayHint : attribute?.displayHint }}
      </small>
    }
    <s-form-error-input
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    />
  </div>
</form>
